
// 手机号校验
export const phoneValidator = (rule, value, callback) => {
    const reg = /^1[3-9]\d{9}$/;
    if (!value) {
        return callback(new Error('请输入手机号'));
    }
    if (!reg.test(value)) {
        return callback(new Error('请输入正确的手机号'));
    }
    return callback();
};

// 邮箱校验
export const emailValidator = (rule, value, callback) => {
    const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!value) {
        return callback();
    }
    if (!reg.test(value)) {
        return callback(new Error('请输入正确的邮箱'));
    }
    return callback();
};

// 金额格式化
// number（要格式化的数字）、decPlaces（小数点后的位数）、decSep（小数分隔符）和thouSep（千位分隔符）
export const formatCurrency = (number, decPlaces, decSep, thouSep) => {
    number = parseFloat(number);
    if (isNaN(number)) return '0.00';
    const sign = number < 0 ? '-' : '';
    number = Math.abs(number);
    number = parseFloat(number.toFixed(decPlaces >= 0 ? decPlaces : 2));
    const parts = number.toFixed(decPlaces).split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1] ? decSep + parts[1] : '';
    const regx = /\B(?=(\d{3})+(?!\d))/g;
    return sign + integerPart.replace(regx, thouSep) + decimalPart;
}